module.exports = __webpack_public_path__ + "static/img/s-local-2.2740dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-local-2.png
// module id = W6z4
// module chunks = 1